<template>
  <calendar-main
    ref="calendarMainRef"
    :add-permission="canManageEvent"
    :delete-permission="canManageEvent"
    :edit-permission="canManageEvent"
    :get-categories="getCategories"
    :get-events="getEvents"
    @delete-event="onDeleteEventHandler"
  />
</template>

<script>
import { CalendarMain } from 'operations';
import service from '@/services/common/dashboard.api.js';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';
import applications from '@/utils/constants/applications.js';

export default {
  name: 'MainEventWrapper',
  mixins: [alertMixin],
  components: { CalendarMain },
  computed: {
    canManageEvent() {
      return this.userHasPermissions('rempro.home.event.management');
    },
  },
  methods: {
    getEvents(categoryId) {
      return service.fetchEvents(categoryId, applications.RemPro);
    },
    getCategories() {
      return service.fetchCategory();
    },
    async refreshEvents() {
      await this.$refs.calendarMainRef.init();
    },
    async onDeleteEventHandler(id) {
      if (id) {
        const result = (await service.deleteEvent(id)).data;
        if (result) {
          this.ShowToast(
            'Proceso Exitoso.',
            'El evento ha sido eliminado exitosamente.',
            'success'
          );
          await this.refreshEvents();
        }
      }
    },
  },
};
</script>
